import React from "react";
import {useState} from "../state/useState";
import {order} from "../service/RechargeService";
import {redirectTo} from "../state/action";
import {Membership} from "./Membership";
import {Email} from "./Email";

export function ConfirmVoucherData({deliveryType, operatorName, membershipNumber, amount, userName, email}) {

    function render() {
        if (deliveryType && deliveryType.index == 1) {
            return <ConfirmMembershipData operatorName={operatorName} amount={amount}
                                          membershipNumber={membershipNumber} userName={userName}/>
        } else if (deliveryType && deliveryType.index == 2) {
            return <ConfirmEmailData operatorName={operatorName} amount={amount} email={email}/>
        } else {
            return <ConfirmEmailData operatorName={operatorName} amount={amount} email={email}/>
        }
    }


    return render();
}

function ConfirmMembershipData({operatorName, amount, membershipNumber, userName}) {
    return <>
        <blockquote><p>Usluga: <strong>{operatorName}</strong></p></blockquote>
        <input type="hidden" name="op" ng-model="operaterData.operater.index"
               value="{{operaterData.operater.index}}"/>
        <blockquote><p>Iznos dopune: <strong>{amount} KM</strong></p></blockquote>
        <input type="hidden" name="amt" ng-model="operaterData.amount"
               value="{{operaterData.amount}}"/>
        <blockquote><p>Članski broj: <strong>{membershipNumber}</strong></p></blockquote>
        <input type="hidden" name="phN" ng-model="operaterData.membershipNumber"
               value="{{operaterData.membershipNumber}}"/>
        <blockquote><p>Ime i prezime: <strong>{userName}</strong></p></blockquote>
        <input type="hidden" name="phN" ng-model="operaterData.membershipNumber"
               value="{{operaterData.membershipNumber}}"/>

        <input type="hidden" name="com" value=""/>
    </>

}


function ConfirmEmailData({operatorName, amount, email}) {
    return <>
        <blockquote><p>Usluga: <strong>{operatorName}</strong></p></blockquote>
        <input type="hidden" name="op" ng-model="operaterData.operater.index"
               value="{{operaterData.operater.index}}"/>
        <blockquote><p>Iznos dopune: <strong>{amount && amount.toFixed(2)} KM</strong></p></blockquote>
        <input type="hidden" name="amt" ng-model="operaterData.amount"
               value="{{operaterData.amount}}"/>
        <blockquote><p>Email: <strong>{email}</strong></p></blockquote>
        <input type="hidden" name="phN" ng-model="operaterData.membershipNumber"
               value="{{operaterData.membershipNumber}}"/>
        <input type="hidden" name="com" value=""/>
    </>

}